const initialState = {
  step: 0,
};

export default function start(state = initialState) {
  return state;
}
